<nz-table
  [nzData]="dataToUse"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
  id="selected-tbl"
  class="ticker-list"
  [style.maxHeight]="maxHeight"
  *ngIf="dataToUse && dataToUse.length"
>
  <tbody cdkDropList (cdkDropListDropped)="drop($event)" class="company">
    <tr *ngFor="let row of dataToUse" cdkDrag class="selected-ticker">
      <td>
        <va-icon size="small" name="grip-vertical" class="drag-icon"></va-icon>
        <span class="line-name">
          <ng-container *ngIf="company">{{ row[company] }}: </ng-container>
          {{ row[field] }}
        </span>
        <va-icon
          *ngIf="!row.tickerDeleteDisabled"
          size="small"
          name="close"
          class="remove-comp"
          (click)="removeModalData(row)"
        ></va-icon>
      </td>
    </tr>
  </tbody>
</nz-table>
